import React from "react";
import { connect } from "react-redux";
import MatButton from "../../components/common/Mat/MatButton";
import MatSpinner from "../../components/common/Mat/MatSpinner";
import { loadNokForOrder } from "../actions/resultsActions";

export default connect()(({ value, dispatch, row }) => {
    if (value.isLoading) {
        return <MatSpinner slim />;
    }
    if (value.data) {
        return (
            <div>
                Ext NoK: {value.data.external} Int NoK: {value.data.internal}
            </div>
        );
    }
    return (
        <div>
            <MatButton slim primary onClick={() => dispatch(loadNokForOrder(row._id))}>
                Count
            </MatButton>
        </div>
    );
});
